"use client";

import { Skeleton, SkeletonText, SkeletonCard, SkeletonList } from "@/components/ui/skeleton";

export default function AppLoading() {
  return (
    <main className="flex min-h-screen p-6">
      <div className="mx-auto max-w-7xl w-full space-y-6 animate-fade-in">
        <div className="flex h-10 items-center justify-between gap-4">
          <Skeleton variant="text" className="h-6 w-48" />
          <div className="flex items-center gap-2">
            <Skeleton variant="rectangular" className="h-9 w-64" />
            <Skeleton variant="circular" />
            <Skeleton variant="circular" />
            <Skeleton variant="circular" />
          </div>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
        </div>
        <SkeletonList items={5} />
      </div>
    </main>
  );
}
